/** Local calendar date as YYYY-MM-DD (browser timezone — matches assignment overdue logic). */
export function localIsoDate(ref: Date = new Date()): string {
  const y = ref.getFullYear();
  const m = String(ref.getMonth() + 1).padStart(2, '0');
  const d = String(ref.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/** Start of local calendar day for date comparisons. */
export function startOfLocalDay(ref: Date = new Date()): Date {
  const d = new Date(ref);
  d.setHours(0, 0, 0, 0);
  return d;
}

export function parseTimestamp(iso: string | null | undefined): Date | null {
  if (!iso) return null;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** True when the instant falls on the same local calendar day as `ref`. */
export function isSameLocalDay(iso: string | null | undefined, ref: Date = new Date()): boolean {
  const parsed = parseTimestamp(iso);
  if (!parsed) return false;
  return localIsoDate(parsed) === localIsoDate(ref);
}

/** Exclude future timestamps from activity timelines. */
export function isPastOrPresentTimestamp(iso: string | null | undefined, now: Date = new Date()): boolean {
  const parsed = parseTimestamp(iso);
  if (!parsed) return false;
  return parsed.getTime() <= now.getTime();
}
